$(() => $('#clinical_alert_config_expiry_days_custom').on('click', () => $('#clinical_alert_config_expiry_days_other').prop('checked', true)));
